import React, {
  useCallback, useEffect,
} from 'react';
import {
  Link, useParams,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoChevronBack } from 'react-icons/io5';
import { GoPencil } from 'react-icons/go';

import { getCongressAction } from '../../../actions/congressesActions';

import Button from '../../../lib/HooksFormFields/Button';

import styles from './CongressView.module.scss';
import Infos from '../../../components/Congresses/CongressView/Infos/Infos';

export default function CongressView() {
  const id = useParams()?.id;
  const { congress } = useSelector((state) => state.congresses);

  const dispatch = useDispatch();

  function formatDate(date) {
    const dayOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    };
    const hourOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    };
    return `${new Intl.DateTimeFormat('fr', dayOptions).format(new Date(date))} à ${new Intl.DateTimeFormat('fr', hourOptions).format(new Date(date))}`;
  }

  const getCongress = useCallback(() => {
    getCongressAction(dispatch, id);
  }, [dispatch, id]);

  useEffect(() => {
    if (id) {
      getCongress();
    }
  }, []);

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.title}>
          <h2>{congress?.name
              && <span>{congress.name}</span>
            }
          </h2>
          <Link to={'/congress'} className={styles.link}>
            <IoChevronBack size={20}/> retour à la liste
          </Link>
        </div>
        <div className={styles['btn-container']}>
          <div className={styles['update-date']}>
            {congress?.updatedAt && <p>
              Dernière modification : <span>{formatDate(congress.updatedAt)}</span>
            </p>}
          </div>
          <Link to={`/congress/edit/${id}`} className={styles.link}>
            <Button
              className={styles.edit}>
              <span>Editer la fiche </span>
              <GoPencil size={20} />
            </Button>
          </Link>
        </div>
      </header>
      <main className={`${styles.content}`}>
        {congress?._id && (
          <Infos congress={congress} />
        )}
      </main>
    </div>
  );
}
